import React from "react";

import { CircularProgress } from "@mui/material";
import {
  Constants as GridConstants,
  Icons as GridIcons,
} from "Components/AppGrid/shipeezi-new-grid";
import { useTranslation } from "react-i18next";

import { DefaultTooltip } from "../../../../../../../../../components/Generic/Tooltip";
import useStyles from "./styles";

interface Props {
  id: number;
  loading: boolean;
  handleOnClick: (id: number) => void;
}

const ChangeStatusButton = (props: Props) => {
  const { id, handleOnClick, loading } = props;

  const { t: translate } = useTranslation();
  const classes = useStyles();

  if (loading) return <CircularProgress size={20} />;

  return (
    <DefaultTooltip title={translate("changeStatus")} placement="top">
      <div>
        <GridIcons.status
          size={GridConstants.defaultRowActionSize}
          data-cy="change-status"
          color={GridConstants.defaultColorIcon}
          className={classes.button}
          onClick={() => handleOnClick(id)}
        />
      </div>
    </DefaultTooltip>
  );
};

export default ChangeStatusButton;
